// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./enterpriseRpcApi";

export let rootBackendApi = new Api();
